import React from 'react';

class TypingSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      typing: props.typing,
    };
    this.ee = props.ee;
  }

  onClick() {
    const newState = !this.props.typing;
    if (newState === false)
      this.ee.emit('hu-lb-key-arrowdown');

    setGlobalState({
      typing: newState,
    });
  }

  render() {
    const typing = this.props.typing;

    return (
      <div className="hu-skip-pause hu-flex hu-items-center hu-a-right">
        { typing ? // SKIP PAUSE
          <button className="skip-pause-button skip-btn hu-border-color_contrast" onClick={this.onClick.bind(this)}>
            <svg width="27px" height="23px" viewBox="0 0 27 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-152.000000, -956.000000)" fill="#5D4161">
                  <path className="hu-fill_contrast" d="M163.0876,978.49 C162.867599,978.209999 162.7776,977.890002 162.8176,977.53 C162.857601,977.169998 163.017599,976.880001 163.2976,976.66 L174.7276,967.450001 L163.3576,958.300001 C163.077599,958.08 162.917601,957.790003 162.8776,957.430001 C162.8376,957.069999 162.927599,956.750002 163.1476,956.470001 C163.367601,956.19 163.657599,956.030001 164.0176,955.990001 C164.377602,955.950001 164.697599,956.04 164.9776,956.260001 L177.6376,966.430001 C177.977601,966.690002 178.1476,967.029998 178.1476,967.450001 C178.1476,967.870003 177.977601,968.209999 177.6376,968.47 L164.9176,978.7 C164.677599,978.900001 164.407602,979 164.1076,979 C163.687598,979 163.347602,978.830002 163.0876,978.49 Z M153.187601,978.49 C152.9676,978.209999 152.877601,977.890002 152.917601,977.53 C152.957601,977.169998 153.117599,976.880001 153.397601,976.66 L164.8276,967.450001 L153.457601,958.300001 C153.177599,958.08 153.017601,957.790003 152.977601,957.430001 C152.937601,957.069999 153.0276,956.750002 153.247601,956.470001 C153.467602,956.19 153.757599,956.030001 154.117601,955.990001 C154.477603,955.950001 154.797599,956.04 155.077601,956.260001 L167.7376,966.430001 C168.077602,966.690002 168.2476,967.029998 168.2476,967.450001 C168.2476,967.870003 168.077602,968.209999 167.7376,968.47 L155.017601,978.7 C154.7776,978.900001 154.507602,979 154.207601,979 C153.787599,979 153.447602,978.830002 153.187601,978.49 Z" id=""></path>
                </g>
              </g>
            </svg>
          </button>
          : // APPLY PAUSE
          <button className="skip-pause-button apply-btn hu-border-color_contrast" onClick={this.onClick.bind(this)}>
            <svg width="24px" height="5px" viewBox="0 0 24 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-154.000000, -965.000000)" fill="#5D4161">
                  <path className="hu-fill_accent" d="M154.552601,966.115001 C154.182599,966.485002 153.997601,966.939998 153.997601,967.480001 C153.997601,968.020003 154.182599,968.474999 154.552601,968.845 C154.922603,969.215002 155.377598,969.4 155.917601,969.4 C156.457603,969.4 156.912599,969.215002 157.282601,968.845 C157.652602,968.474999 157.837601,968.020003 157.837601,967.480001 C157.837601,966.939998 157.652602,966.485002 157.282601,966.115001 C156.912599,965.744999 156.457603,965.560001 155.917601,965.560001 C155.377598,965.560001 154.922603,965.744999 154.552601,966.115001 Z M164.1526,966.115001 C163.782598,966.485002 163.5976,966.939998 163.5976,967.480001 C163.5976,968.020003 163.782598,968.474999 164.1526,968.845 C164.522602,969.215002 164.977598,969.4 165.5176,969.4 C166.057603,969.4 166.512598,969.215002 166.8826,968.845 C167.252602,968.474999 167.4376,968.020003 167.4376,967.480001 C167.4376,966.939998 167.252602,966.485002 166.8826,966.115001 C166.512598,965.744999 166.057603,965.560001 165.5176,965.560001 C164.977598,965.560001 164.522602,965.744999 164.1526,966.115001 Z M173.7526,966.115001 C173.382598,966.485002 173.1976,966.939998 173.1976,967.480001 C173.1976,968.020003 173.382598,968.474999 173.7526,968.845 C174.122602,969.215002 174.577597,969.4 175.1176,969.4 C175.657603,969.4 176.112598,969.215002 176.4826,968.845 C176.852602,968.474999 177.0376,968.020003 177.0376,967.480001 C177.0376,966.939998 176.852602,966.485002 176.4826,966.115001 C176.112598,965.744999 175.657603,965.560001 175.1176,965.560001 C174.577597,965.560001 174.122602,965.744999 173.7526,966.115001 Z" id=""></path>
                </g>
              </g>
            </svg>
          </button>
        }
        { typing ?
          <p className="hu-color_contrast hu-s-12 hu-t-uppercase">
            Skip pause<br/><span className="skip-text-sub hu-s-10 hu-w-bold">between messages</span>
          </p>
          :
          <p className="hu-color_contrast hu-s-12 hu-t-uppercase">
            Apply pause<br/><span className="skip-text-sub hu-s-10 hu-w-bold">between messages</span>
          </p>
        }
      </div>
    );
  }
}

export default TypingSwitch;


// WEBPACK FOOTER //
// ./app/js/components/typing-switch/TypingSwitch.js